const TAB_KEY = "trackTabId";

const randomPart = (length) => Math.random().toString(36).slice(2, 2 + length);

const readTabId = () => {
  try {
    const existing = sessionStorage.getItem(TAB_KEY);
    if (existing) return existing;
    const fresh = `${Date.now().toString(36)}-${randomPart(6)}`;
    sessionStorage.setItem(TAB_KEY, fresh);
    return fresh;
  } catch (error) {
    return `tab-${randomPart(6)}`;
  }
};

const tabId = readTabId();
let counter = 0;

export const getTabId = () => tabId;

export const newEventId = () => {
  counter += 1;
  return `${tabId}-${Date.now().toString(36)}-${counter.toString(36)}-${randomPart(3)}`;
};

export const stampEvent = (event) => ({
  ...event,
  tab: event.tab || tabId,
  event_id: event.event_id || newEventId(),
});

let workflowCounter = 0;

export const newWorkflowKey = () => {
  workflowCounter += 1;
  return `${tabId}-wf-${Date.now().toString(36)}-${workflowCounter.toString(36)}`;
};
